import { ArrowsClockwise } from "@phosphor-icons/react";

/**
 * Confirmation modal shown when the user clicks "Quiero modificar la música".
 * Warns about free-vs-paid cost before triggering /regenerate-audio.
 */
export const AudioRegenConfirmModal = ({
  open,
  regenInfo,
  loading,
  onCancel,
  onConfirm,
  onBuyMore,
}) => {
  if (!open) return null;

  const audioInfo = regenInfo?.kinds?.audio || {};
  const isFreeNext = !!audioInfo.is_free_next;
  const credits = regenInfo?.regen_credits || 0;
  const canFreeOrPaid = isFreeNext || credits > 0;

  return (
    <div className="fixed inset-0 z-[80] bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center p-4" data-testid="audio-regen-confirm-modal">
      <div className="w-full max-w-md rounded-3xl bg-[#0d0d0d] border border-white/10 p-6 shadow-2xl">
        <div className="flex justify-center mb-4">
          <div className="w-14 h-14 rounded-full bg-[#FFB800]/15 flex items-center justify-center">
            <ArrowsClockwise size={26} weight="bold" className="text-[#FFB800]" />
          </div>
        </div>
        <h3 className="font-display font-bold text-xl text-center mb-2">Generar una nueva versión</h3>
        <p className="text-sm text-white/60 text-center mb-5">
          {isFreeNext
            ? <>Tienes <span className="text-[#B4F34A] font-bold">1 cambio gratis</span> incluido. Es la única versión gratuita — después cada cambio cuesta $20 MXN.</>
            : credits > 0
              ? <>Esto consumirá <span className="text-white font-semibold">1 cambio extra</span> ($20 MXN). Tienes <span className="text-[#FFB800] font-semibold">{credits}</span> disponible{credits === 1 ? "" : "s"}.</>
              : <>Ya usaste tu cambio gratis y no tienes cambios extra. Te llevaremos a comprar uno por $20 MXN para continuar.</>}
        </p>
        <div className="rounded-xl bg-[#FFB800]/5 border border-[#FFB800]/20 p-3 mb-5">
          <p className="text-xs text-white/70 leading-relaxed">
            💡 <span className="text-white font-semibold">Tip:</span> antes de regenerar, escucha de nuevo la canción 2 o 3 veces. Muchas veces la segunda escucha gusta más que la primera.
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <button
            onClick={canFreeOrPaid ? onConfirm : onBuyMore}
            disabled={loading}
            className="w-full py-3 rounded-full bg-[#FFB800] hover:bg-[#E6A600] text-black font-bold disabled:opacity-50 active:scale-95 transition-all"
            data-testid="confirm-audio-regen"
          >
            {canFreeOrPaid
              ? (isFreeNext ? "Sí, generar nueva versión (gratis)" : "Sí, generar nueva versión (-1 cambio)")
              : "Ir a comprar 1 cambio extra"}
          </button>
          <button
            onClick={onCancel}
            className="w-full py-3 rounded-full bg-white/5 hover:bg-white/10 text-white/70 text-sm"
            data-testid="cancel-audio-regen"
          >
            Mejor la escucho otra vez
          </button>
        </div>
      </div>
    </div>
  );
};
